/**
 * Swiper sliders (enqueued only by blocks/templates that render one).
 */
import Swiper from 'swiper';
import { Navigation, Pagination, Controller, A11y, Autoplay } from 'swiper/modules';

Swiper.use( [ Navigation, Pagination, Controller, A11y, Autoplay ] );

const init = () => {
	const story = document.querySelector( '.swiper--story' );
	const years = document.querySelector( '.swiper--years' );
	if ( story && years ) {
		const storySwiper = new Swiper( story, {
			slidesPerView: 1,
			spaceBetween: 24,
			autoHeight: true,
			navigation: { nextEl: '.swiper-button-next--story', prevEl: '.swiper-button-prev--story' },
		} );
		const yearsSwiper = new Swiper( years, {
			slidesPerView: 'auto',
			centeredSlides: true,
			centerInsufficientSlides: true,
			spaceBetween: 16,
			breakpoints: { 640: { spaceBetween: 24 }, 1024: { spaceBetween: 48 } },
		} );
		storySwiper.controller.control = yearsSwiper;
		yearsSwiper.controller.control = storySwiper;
	}

	document.querySelectorAll( '.swiper--cards' ).forEach( ( el ) => {
		new Swiper( el, {
			slidesPerView: 'auto',
			spaceBetween: 8,
			pagination: { el: el.querySelector( '.swiper-pagination--cards' ), clickable: true },
			breakpoints: { 640: { spaceBetween: 16 }, 1024: { slidesPerView: 3, spaceBetween: 24 } },
		} );
	} );

	document.querySelectorAll( '.swiper--hero' ).forEach( ( el ) => {
		const delay = parseInt( el.dataset.autoplay || '0', 10 );
		const reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
		new Swiper( el, {
			slidesPerView: 1,
			loop: el.querySelectorAll( '.swiper-slide' ).length > 1,
			autoHeight: true,
			autoplay: delay > 0 && ! reduce ? { delay, pauseOnMouseEnter: true, disableOnInteraction: true } : false,
			pagination: { el: el.querySelector( '.swiper-pagination--hero' ), clickable: true },
		} );
	} );

	document.querySelectorAll( '.swiper--ebook' ).forEach( ( el ) => {
		new Swiper( el, { slidesPerView: 'auto', spaceBetween: 24 } );
	} );

	document.querySelectorAll( '.swiper--articles' ).forEach( ( el ) => {
		new Swiper( el, {
			slidesPerView: 'auto',
			watchOverflow: true,
			spaceBetween: 16,
			pagination: { el: el.querySelector( '.swiper-pagination--articles' ), clickable: true },
			navigation: {
				nextEl: el.querySelector( '.swiper-button-next--articles' ),
				prevEl: el.querySelector( '.swiper-button-prev--articles' ),
			},
			breakpoints: { 640: { slidesPerView: 3 }, 1024: { slidesPerView: 3, spaceBetween: 24 } },
		} );
	} );

	// Events: slider on small screens only, plain grid from 64em.
	const large = window.matchMedia( '(min-width: 64em)' );
	let events = [];
	const toggleEvents = () => {
		if ( large.matches ) {
			events.forEach( ( s ) => s.destroy( true, true ) );
			events = [];
		} else if ( ! events.length ) {
			events = [ ...document.querySelectorAll( '.swiper--events' ) ].map(
				( el ) =>
					new Swiper( el, {
						slidesPerView: 1,
						spaceBetween: 8,
						pagination: { el: el.querySelector( '.swiper-pagination--events' ), clickable: true },
					} )
			);
		}
	};
	large.addEventListener( 'change', toggleEvents );
	toggleEvents();
};

document.readyState === 'loading' ? document.addEventListener( 'DOMContentLoaded', init ) : init();
